/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    byGUID: {},
    current: undefined,
    all: [],
};

const layout = createSlice({
    name: "layout",

    initialState,

    reducers: {
        setLayouts (state, action) {
            const layouts = action.payload;
            state.all = layouts;
        },
        setLayoutItem (state, action) {
            const layout = action.payload;
            const guid = layout.guid;
            state.byGUID[guid] = layout;
            state.current = layout;
        },
    },
});

export const layoutReducer = layout.reducer;

export const {
    setLayoutItem,
    setLayouts
} = layout.actions;
